import React from "react";
import FormPackage from "../FormPackage";

export default function DetailItemComponent({ initialValues }) {
  return (
    <FormPackage isView handleSubmit={() => {}} initialValues={initialValues} />
  );
}
